module.exports = __webpack_public_path__ + "static/media/illustration-building-wide.c6cdef59.png";